import { ADD_TO_CART } from "./actionTypes";
import { INCREMENT } from "./actionTypes";
import { DECREMENT } from "./actionTypes";

export const add_to_cart = (id, name, price, quantity) => {
    return {
        type: ADD_TO_CART,
        payload: {
            id: id,
            name: name,
            price: price,
            quantity: quantity
        }
    }
}

export const increment = (id) => {
    return {
        type: INCREMENT,
        payload:id
    };
};

export const decrement = (id) => {
    return {
        type: DECREMENT,
        payload:id
    };
};
